<template>
  <draggable
    handle=".handle"
    @change="change" :list="value" class="dragArea" tag="ul" :group="{ name: 'g1' }"
  >
    <li v-for="el in value" :key="el.id" class="li li-handle">
      <div class="list-container">
        <div class="list-name handle">
          <i class="fa fa-align-justify"></i>
          <span @click="editObject = el">{{ el.name }}</span>
          <router-link :to="`/dashboard/dir/${el.id}/inputs`">
            <i class="fa fa-edit"></i>
          </router-link>

        </div>
        <div class="controls">
          <AddObject :parentId="el.id" @update="$emit('update')">
            <span>+</span>
          </AddObject>
          <span class="delete" @click="deleteObject(el.id)">-</span>
          <router-link
            :to="`/dashboard/works/list/job?dir=${el.id}${$route.query.plan ? '&plan=' + $route.query.plan + '&name=' + $route.query.name: ''}${$route.query.version ? '&version=' + $route.query.version + '&name=' + $route.query.name: ''}`">
            <img src="@/assets/settings.svg"/>
          </router-link>
        </div>
      </div>
      <nested-draggable @fetchTree="$emit('fetchTree')" @update="$emit('update')" @input="change" :value="el.objects" :parentId="el.id"/>
    </li>

    <el-dialog
      title="Редактирование раздела"
      :visible.sync="editObject"
      width="30%"
      :before-close="handleClose"
    >
      <el-form>
        <el-form-item label="Название раздела">
          <el-input
            @input="change(value)"
            v-model="editObject && editObject.name" placeholder="Название раздела"
          />
        </el-form-item>
        <div>
        <el-button style="width: 100%" @click="openZone(editObject)">Зоны</el-button>
        </div>
        <div style="margin-top: 10px">
        <el-button style="width: 100%" @click="openDocs(editObject)">Разделы документации</el-button>
        </div>
      </el-form>
    </el-dialog>

    <PermissionZone ref="zone" @fetchTree="$emit('fetchTree')"/>
    <PermissionDocs ref="docs" @fetchTree="$emit('fetchTree')"/>

  </draggable>
</template>
<script>
import draggable from 'vuedraggable';
import AddObject from '@/views/Dashboard/Dirs/components/AddDir';
import firebase from 'firebase';
import PermissionZone from "./PermissionZone";
import PermissionDocs from "./PermissionDocs";

export default {
  props: {
    value: {
      type: Array,
    },
    parentId: String,
    isMain: Boolean,
  },
  components: {
    PermissionDocs,
    PermissionZone,
    AddObject,
    draggable,
  },
  data() {
    return {
      editObject: null,
      editZone: false
    };
  },
  methods: {
    openZone(editObject) {
      this.$refs.zone.openDialog(editObject)
    },
    openDocs(editObject) {
      this.$refs.docs.openDialog(editObject)

    },
    fire() {
      if(this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if(this.$route.query.plan) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    handleClose() {
      this.editObject = null;
    },
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      let _value = [...this.value];

      if (value.added) {
        value.added.element.parentId = this.parentId;
        _value[value.added.newIndex] = value.added.element;
      }

      this.$emit('input', _value);
    },
    update() {
      this.$emit('update');
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить этот раздел?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {

        this.fire()
          .collection('dirs')
          .doc(id).delete()
          .then(async () => {


            const objectskills =
              await  this.fire()
                .collection('dirs')
                .where(`parentId`, '==', id)
                .get();

            const batch = firebase.firestore().batch();
            const dirs = [id]

            objectskills.forEach(doc => {
              dirs.push(doc.id)
              batch.delete(doc.ref);
            });

            // await batch.commit();


            const workskils =  await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('works_type')
              .where(`dir`, 'in', dirs).get();

            workskils.forEach(doc => {
              batch.delete(doc.ref);
            });

            await batch.commit();


            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Раздел удален',
              type: 'success',
            });
          });
      });
    },
  },

  name: 'nested-draggable',
};
</script>
<style scoped lang="scss">
.dragArea {
  min-height: 20px;
  padding: 10px 0 0 0;
  margin-left: 14px;
}

.list-container {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
  background: #f7f7f7;
  border-radius: 4px;
  min-height: 50px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  padding: 0 10px;
  cursor: pointer;
}

.controls {
  display: flex;
  justify-content: space-between;
  width: 140px;
  font-size: 22px;
  font-weight: 400;

  .delete {
    font-size: 36px;
    font-weight: 100;
    color: #c0392b;
  }
}

.list-name {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.drag-handle {
  background: #eee;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  margin-left: -10px;
}

.handle {
  i {
    margin-right: 10px;
  }
}

.controls-arrow {
  margin-right: 10px;
  display: flex;
  align-items: center;

  i {
    font-size: 16px;
    margin-right: 10px;
  }
}

.fa-edit {
  margin-left: 8px;
  color: #1e1e21 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Dirs/components/List.vue